<form [formGroup]="loanForm" class="loan-form">
  <!-- Loan Information Section -->
  <div class="form-section">
    <div class="form-grid">
      <!-- State Registered Business Entity -->
      <div class="form-group full-width">
        <span class="group-label"
          >Do you have a state-registered business entity?</span
        >
        <div class="radio-options">
          <div class="radio-item">
            <input
              id="stateRegisteredYes"
              type="radio"
              formControlName="stateRegisteredEntity"
              [value]="true"
            />
            <label for="stateRegisteredYes">Yes</label>
          </div>
          <div class="radio-item">
            <input
              id="stateRegisteredNo"
              type="radio"
              formControlName="stateRegisteredEntity"
              [value]="false"
            />
            <label for="stateRegisteredNo">No</label>
          </div>
        </div>
      </div>

      <!-- Requesting Loan Amount -->
      <div class="form-group">
        <label for="requestingLoanAmount"
          >Requesting Loan Amount (in USD)</label
        >
        <input
          id="requestingLoanAmount"
          type="number"
          step="any"
          formControlName="requestingLoanAmount"
          placeholder="0.00"
        />
        @if (
          loanForm.get("requestingLoanAmount")?.touched &&
          loanForm.get("requestingLoanAmount")?.invalid
        ) {
          <span class="error-message">{{
            getErrorMessage("requestingLoanAmount")
          }}</span>
        }
      </div>

      <!-- Loan Term in Months -->
      <div class="form-group">
        <label for="loanTermMonths">Loan Term in Months</label>
        <input
          id="loanTermMonths"
          type="number"
          step="1"
          formControlName="loanTermMonths"
          placeholder="0"
        />
        @if (
          loanForm.get("loanTermMonths")?.touched &&
          loanForm.get("loanTermMonths")?.invalid
        ) {
          <span class="error-message">{{
            getErrorMessage("loanTermMonths")
          }}</span>
        }
      </div>

      <!-- Total Revenue -->
      <div class="form-group">
        <label for="totalRevenue">Total Revenue (in USD)</label>
        <input
          id="totalRevenue"
          type="number"
          step="any"
          formControlName="totalRevenue"
          placeholder="0.00"
        />
        @if (
          loanForm.get("totalRevenue")?.touched &&
          loanForm.get("totalRevenue")?.invalid
        ) {
          <span class="error-message">{{
            getErrorMessage("totalRevenue")
          }}</span>
        }
      </div>

      <!-- What type of capital product are you looking for? -->
      <div class="form-group full-width">
        <span class="group-label required"
          >What type of capital product are you looking for?</span
        >
        <div class="checkbox-grid" formGroupName="loanType">
          @for (loanType of loanTypeOptions; track loanType) {
            <div class="checkbox-item">
              <input
                type="checkbox"
                [id]="'loanType' + sanitizeKey(loanType)"
                [formControlName]="sanitizeKey(loanType)"
              />
              <label [for]="'loanType' + sanitizeKey(loanType)">{{
                loanType
              }}</label>
            </div>
          }
        </div>
      </div>

      <!-- Prescreening Question -->
      @if (showPrescreeningQuestion) {
        <div class="form-group full-width">
          <span class="group-label required"
            >If you are looking for a Business loan of any type, would you fill
            out a prescreening form to assist a Loan officer process your
            application quickly?</span
          >
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="prescreeningYes"
                type="radio"
                formControlName="willingToFillPrescreeningForm"
                [value]="true"
              />
              <label for="prescreeningYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="prescreeningNo"
                type="radio"
                formControlName="willingToFillPrescreeningForm"
                [value]="false"
              />
              <label for="prescreeningNo">No</label>
            </div>
          </div>
        </div>
      }

      <!-- Simplified Form Questions (when user selects "No" to prescreening) -->
      @if (showSimplifiedForm) {
        <!-- Credit Score Range -->
        <div class="form-group full-width">
          <label for="creditScoreRange" class="required"
            >If you are looking for a loan, can you self-report your credit
            score range?</label
          >
          <select id="creditScoreRange" formControlName="creditScoreRange">
            <option value="">Select a range</option>
            @for (scoreRange of creditScoreOptions; track scoreRange) {
              <option [value]="scoreRange">{{ scoreRange }}</option>
            }
          </select>
        </div>

        <!-- Have Co-Signer -->
        <div class="form-group full-width">
          <span class="group-label required"
            >Would you have a co-signer if you applied for a loan?</span
          >
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="coSignerYes"
                type="radio"
                formControlName="haveCoSigner"
                [value]="true"
              />
              <label for="coSignerYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="coSignerNo"
                type="radio"
                formControlName="haveCoSigner"
                [value]="false"
              />
              <label for="coSignerNo">No</label>
            </div>
          </div>
        </div>

        <!-- Have Business Plan -->
        <div class="form-group full-width">
          <span class="group-label required">Do you have a business plan?</span>
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="businessPlanYes"
                type="radio"
                formControlName="haveBusinessPlan"
                value="yes"
              />
              <label for="businessPlanYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="businessPlanNo"
                type="radio"
                formControlName="haveBusinessPlan"
                value="no"
              />
              <label for="businessPlanNo">No</label>
            </div>
            <div class="radio-item">
              <input
                id="businessPlanNeedHelp"
                type="radio"
                formControlName="haveBusinessPlan"
                value="need_help"
              />
              <label for="businessPlanNeedHelp">I need help making one</label>
            </div>
          </div>
        </div>

        <!-- Have Financial Projections -->
        <div class="form-group full-width">
          <span class="group-label required"
            >Have you created financial projections?</span
          >
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="financialProjectionsYes"
                type="radio"
                formControlName="haveFinancialProjections"
                [value]="true"
              />
              <label for="financialProjectionsYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="financialProjectionsNo"
                type="radio"
                formControlName="haveFinancialProjections"
                [value]="false"
              />
              <label for="financialProjectionsNo">No</label>
            </div>
          </div>
        </div>

        <!-- Financial Documentation (for simplified form) -->
        <div class="form-group full-width">
          <span class="group-label required"
            >What financial documentation do you have available?</span
          >
          <div class="checkbox-grid" formGroupName="financialDocumentation">
            @for (option of financialDocOptions; track option) {
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  [id]="'simplifiedFinDoc' + sanitizeKey(option)"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'simplifiedFinDoc' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>
      }

      <!-- Ownership Structure -->
      @if (showFullForm) {
        <div class="form-group full-width">
          <div class="ownership-structure-header">
            <span class="group-label required">Ownership Structure</span>
          </div>
          <div class="ownership-table">
            <div class="ownership-table-header">
              <div class="ownership-col-name">Owner Name</div>
              <div class="ownership-col-percentage">% Ownership</div>
              <div class="ownership-col-other">
                % Ownership in OTHER businesses (if applicable)
              </div>
              <div class="ownership-col-actions">Actions</div>
            </div>
            @for (row of ownershipStructure; track $index) {
              <div class="ownership-table-row">
                <div
                  class="ownership-col-name"
                  style="
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                  "
                >
                  <input
                    type="text"
                    [(ngModel)]="row.ownerName"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Required"
                    required
                    [class.is-invalid]="
                      formSubmitted &&
                      (!row.ownerName || row.ownerName.trim() === '')
                    "
                    style="width: 100%"
                  />
                  @if (
                    formSubmitted &&
                    (!row.ownerName || row.ownerName.trim() === "")
                  ) {
                    <span
                      class="error-message"
                      style="
                        margin-top: 2px;
                        font-size: 0.75rem;
                        white-space: nowrap;
                      "
                      >This field is required</span
                    >
                  }
                </div>
                <div
                  class="ownership-col-percentage"
                  style="
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                  "
                >
                  <input
                    type="number"
                    [(ngModel)]="row.ownershipPercentage"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Required"
                    min="0"
                    max="100"
                    required
                    [class.is-invalid]="
                      formSubmitted &&
                      (row.ownershipPercentage === undefined ||
                        row.ownershipPercentage === null ||
                        row.ownershipPercentage < 0 ||
                        row.ownershipPercentage > 100 ||
                        !isValidDecimal(row.ownershipPercentage))
                    "
                    style="width: 100%"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (
                    formSubmitted &&
                    (row.ownershipPercentage === undefined ||
                      row.ownershipPercentage === null ||
                      row.ownershipPercentage < 0 ||
                      row.ownershipPercentage > 100 ||
                      !isValidDecimal(row.ownershipPercentage))
                  ) {
                    <span
                      class="error-message"
                      style="
                        margin-top: 2px;
                        font-size: 0.75rem;
                        white-space: nowrap;
                      "
                    >
                      {{
                        row.ownershipPercentage === undefined ||
                        row.ownershipPercentage === null
                          ? "Required"
                          : !isValidDecimal(row.ownershipPercentage)
                            ? "Max 2 decimal places allowed"
                            : "Must be 0-100"
                      }}
                    </span>
                  }
                </div>
                <div
                  class="ownership-col-other"
                  style="
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                  "
                >
                  <input
                    type="number"
                    [(ngModel)]="row.otherBusinessesPercentage"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="0-100"
                    min="0"
                    max="100"
                    [class.is-invalid]="
                      formSubmitted &&
                      row.otherBusinessesPercentage !== undefined &&
                      row.otherBusinessesPercentage !== null &&
                      (row.otherBusinessesPercentage < 0 ||
                        row.otherBusinessesPercentage > 100 ||
                        !isValidDecimal(row.otherBusinessesPercentage))
                    "
                    style="width: 100%"
                    (wheel)="$event.preventDefault()"
                  />
                  @if (
                    formSubmitted &&
                    row.otherBusinessesPercentage !== undefined &&
                    row.otherBusinessesPercentage !== null &&
                    (row.otherBusinessesPercentage < 0 ||
                      row.otherBusinessesPercentage > 100 ||
                      !isValidDecimal(row.otherBusinessesPercentage))
                  ) {
                    <span
                      class="error-message"
                      style="
                        margin-top: 2px;
                        font-size: 0.75rem;
                        white-space: nowrap;
                      "
                    >
                      {{
                        !isValidDecimal(row.otherBusinessesPercentage)
                          ? "Max 2 decimal places allowed"
                          : "Must be 0-100"
                      }}
                    </span>
                  }
                </div>
                <div class="ownership-col-actions">
                  <button
                    type="button"
                    class="btn-remove"
                    (click)="removeOwnershipRow($index)"
                    [disabled]="ownershipStructure.length === 1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path
                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                      ></path>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                    </svg>
                  </button>
                </div>
              </div>
            }
            <div class="ownership-table-footer">
              <button
                type="button"
                class="btn-add"
                (click)="addOwnershipRow()"
                [disabled]="!canAddOwner()"
              >
                + Add Owner
              </button>
            </div>
          </div>
          @if (formSubmitted && !isOwnershipStructureValid()) {
            <div class="ownership-validation-message error-message">
              Please fill in valid owner name, ownership percentage (0-100), and
              other businesses percentage (0-100 if applicable)
            </div>
          }
        </div>
      }

      <!-- Loan Use -->
      @if (showFullForm) {
        <div class="form-group full-width">
          <span class="group-label">Loan Use</span>
          <div class="checkbox-grid" formGroupName="loanUse">
            @for (option of loanUseOptions; track option) {
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  [id]="'loanUse' + sanitizeKey(option)"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'loanUse' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>
      }

      <!-- Personal Capital Contribution -->
      @if (showFullForm) {
        <div class="form-group full-width">
          <span class="group-label"
            >Owner contributing personal capital to this project in addition to
            the requested capital amount?</span
          >
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="contributingYes"
                type="radio"
                formControlName="contributingPersonalCapital"
                [value]="true"
              />
              <label for="contributingYes">Yes</label>
            </div>
            <div class="radio-item">
              <input
                id="contributingNo"
                type="radio"
                formControlName="contributingPersonalCapital"
                [value]="false"
              />
              <label for="contributingNo">No</label>
            </div>
          </div>
          @if (showPersonalCapitalPercentage) {
            <div class="custom-input">
              <label for="personalCapitalPercentage"
                >What percentage of the total project cost will owner contribute
                personally?</label
              >
              <input
                id="personalCapitalPercentage"
                type="text"
                formControlName="personalCapitalPercentage"
                placeholder="0"
              />
              @if (
                loanForm.get("personalCapitalPercentage")?.touched &&
                loanForm.get("personalCapitalPercentage")?.invalid
              ) {
                <span class="error-message">{{
                  getErrorMessage("personalCapitalPercentage")
                }}</span>
              }
            </div>
          }
        </div>
      }

      <!-- Available Collateral Types -->
      @if (showFullForm) {
        <div class="form-group full-width">
          <span class="group-label">Available Collateral Types</span>
          <div class="checkbox-grid" formGroupName="collateralTypes">
            @for (option of collateralOptions; track option) {
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  [id]="'collateral' + sanitizeKey(option)"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'collateral' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Income or Revenue Section -->
  @if (showFullForm) {
    <div class="form-section">
      <h3 class="section-title">Income or Revenue</h3>
      <div class="form-grid">
        <!-- Most Recent Business Reporting Period -->
        <div class="form-group full-width">
          <span class="group-label">Most Recent Business Reporting Period</span>
          <div class="radio-options">
            <div class="radio-item">
              <input
                id="periodQ1"
                type="radio"
                formControlName="reportingPeriod"
                [value]="1"
              />
              <label for="periodQ1">Q1</label>
            </div>
            <div class="radio-item">
              <input
                id="periodQ2"
                type="radio"
                formControlName="reportingPeriod"
                [value]="2"
              />
              <label for="periodQ2">Q2</label>
            </div>
            <div class="radio-item">
              <input
                id="periodQ3"
                type="radio"
                formControlName="reportingPeriod"
                [value]="3"
              />
              <label for="periodQ3">Q3</label>
            </div>
            <div class="radio-item">
              <input
                id="periodQ4"
                type="radio"
                formControlName="reportingPeriod"
                [value]="4"
              />
              <label for="periodQ4">Q4</label>
            </div>
          </div>
        </div>

        <!-- Number of Months in the Period -->
        <div class="form-group">
          <label for="monthsInPeriod">Number of Months in the Period</label>
          <input
            id="monthsInPeriod"
            type="number"
            step="1"
            formControlName="monthsInPeriod"
            placeholder="0"
          />
          @if (
            loanForm.get("monthsInPeriod")?.touched &&
            loanForm.get("monthsInPeriod")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("monthsInPeriod")
            }}</span>
          }
        </div>

        <!-- Net Profit or Earnings -->
        <div class="form-group">
          <label for="netProfit">Net Profit or Earnings (in USD)</label>
          <input
            id="netProfit"
            type="number"
            step="any"
            formControlName="netProfit"
            placeholder="0.00"
          />
          @if (
            loanForm.get("netProfit")?.touched &&
            loanForm.get("netProfit")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("netProfit")
            }}</span>
          }
        </div>

        <!-- Depreciation and Amortization -->
        <div class="form-group">
          <label for="depreciation"
            >Depreciation and Amortization (in USD)</label
          >
          <input
            id="depreciation"
            type="number"
            step="any"
            formControlName="depreciation"
            placeholder="0.00"
          />
          @if (
            loanForm.get("depreciation")?.touched &&
            loanForm.get("depreciation")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("depreciation")
            }}</span>
          }
        </div>
      </div>
    </div>
  }

  <!-- Assets and Working Capital Section -->
  @if (showFullForm) {
    <div class="form-section">
      <h3 class="section-title">Assets and Working Capital</h3>
      <div class="form-grid">
        <!-- Total Assets -->
        <div class="form-group">
          <label for="totalAssets">Total Assets (in USD)</label>
          <input
            id="totalAssets"
            type="number"
            step="any"
            formControlName="totalAssets"
            placeholder="0.00"
          />
          @if (
            loanForm.get("totalAssets")?.touched &&
            loanForm.get("totalAssets")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("totalAssets")
            }}</span>
          }
        </div>

        <!-- Cash, Cash Equivalents, and Liquid Assets -->
        <div class="form-group">
          <label for="cashEquivalents"
            >Cash, Cash Equivalents, and Liquid Assets (in USD)</label
          >
          <input
            id="cashEquivalents"
            type="number"
            step="any"
            formControlName="cashEquivalents"
            placeholder="0.00"
          />
          @if (
            loanForm.get("cashEquivalents")?.touched &&
            loanForm.get("cashEquivalents")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("cashEquivalents")
            }}</span>
          }
        </div>

        <!-- Trade Receivables and Prepaid Expenses -->
        <div class="form-group">
          <label for="tradeReceivables"
            >Trade Receivables and Prepaid Expenses (in USD)</label
          >
          <input
            id="tradeReceivables"
            type="number"
            step="any"
            formControlName="tradeReceivables"
            placeholder="0.00"
          />
          @if (
            loanForm.get("tradeReceivables")?.touched &&
            loanForm.get("tradeReceivables")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("tradeReceivables")
            }}</span>
          }
        </div>

        <!-- Inventory Value -->
        <div class="form-group">
          <label for="inventoryValue">Inventory Value (in USD)</label>
          <input
            id="inventoryValue"
            type="number"
            step="any"
            formControlName="inventoryValue"
            placeholder="0.00"
          />
          @if (
            loanForm.get("inventoryValue")?.touched &&
            loanForm.get("inventoryValue")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("inventoryValue")
            }}</span>
          }
        </div>

        <!-- Total Current Liabilities -->
        <div class="form-group">
          <label for="totalCurrentLiabilities"
            >Total Current Liabilities (in USD)</label
          >
          <input
            id="totalCurrentLiabilities"
            type="number"
            step="any"
            formControlName="totalCurrentLiabilities"
            placeholder="0.00"
          />
          @if (
            loanForm.get("totalCurrentLiabilities")?.touched &&
            loanForm.get("totalCurrentLiabilities")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("totalCurrentLiabilities")
            }}</span>
          }
        </div>

        <!-- Shareholder Equity -->
        <div class="form-group">
          <label for="shareholderEquity">Shareholder Equity (in USD)</label>
          <input
            id="shareholderEquity"
            type="number"
            step="any"
            formControlName="shareholderEquity"
            placeholder="0.00"
          />
          @if (
            loanForm.get("shareholderEquity")?.touched &&
            loanForm.get("shareholderEquity")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("shareholderEquity")
            }}</span>
          }
        </div>

        <!-- Net-worth -->
        <div class="form-group">
          <label for="alternativeNetWorth"
            >Alternative Net-worth (in USD)</label
          >
          <input
            id="alternativeNetWorth"
            type="number"
            step="any"
            formControlName="alternativeNetWorth"
            placeholder="0.00"
          />
          @if (
            loanForm.get("alternativeNetWorth")?.touched &&
            loanForm.get("alternativeNetWorth")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("alternativeNetWorth")
            }}</span>
          }
        </div>
      </div>
    </div>
  }

  <!-- Existing Debt Section -->
  @if (showFullForm) {
    <div class="form-section">
      <h3 class="section-title">Existing Debt</h3>
      <div class="form-grid">
        <!-- Outstanding Amount of Existing Business Loans -->
        <div class="form-group">
          <label for="outstandingLoans"
            >Outstanding Amount of Existing Business Loans (in USD)</label
          >
          <input
            id="outstandingLoans"
            type="number"
            step="any"
            formControlName="outstandingLoans"
            placeholder="0.00"
          />
          @if (
            loanForm.get("outstandingLoans")?.touched &&
            loanForm.get("outstandingLoans")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("outstandingLoans")
            }}</span>
          }
        </div>

        <!-- Approved Limit for Existing Credit Lines -->
        <div class="form-group">
          <label for="approvedCreditLimit"
            >Approved Limit for Existing Credit Lines (in USD)</label
          >
          <input
            id="approvedCreditLimit"
            type="number"
            step="any"
            formControlName="approvedCreditLimit"
            placeholder="0.00"
          />
          @if (
            loanForm.get("approvedCreditLimit")?.touched &&
            loanForm.get("approvedCreditLimit")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("approvedCreditLimit")
            }}</span>
          }
        </div>

        <!-- Total Monthly Debt Service Amount -->
        <div class="form-group">
          <label for="monthlyDebtService"
            >Total Monthly Debt Service Amount (in USD)</label
          >
          <input
            id="monthlyDebtService"
            type="number"
            step="any"
            formControlName="monthlyDebtService"
            placeholder="0.00"
          />
          @if (
            loanForm.get("monthlyDebtService")?.touched &&
            loanForm.get("monthlyDebtService")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("monthlyDebtService")
            }}</span>
          }
        </div>
      </div>
    </div>
  }

  <!-- Personal Financial Information Section -->
  @if (showFullForm) {
    <div class="form-section">
      <h3 class="section-title">Personal Financial Information</h3>
      <div class="form-grid">
        <!-- Total Annual Personal Income -->
        <div class="form-group">
          <label for="personalIncome"
            >Total Annual Personal Income (in USD)</label
          >
          <input
            id="personalIncome"
            type="number"
            step="any"
            formControlName="personalIncome"
            placeholder="0.00"
          />
          @if (
            loanForm.get("personalIncome")?.touched &&
            loanForm.get("personalIncome")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("personalIncome")
            }}</span>
          }
        </div>

        <!-- Personal Net Worth -->
        <div class="form-group">
          <label for="personalNetWorth">Personal Net Worth (in USD)</label>
          <input
            id="personalNetWorth"
            type="number"
            step="any"
            formControlName="personalNetWorth"
            placeholder="0.00"
          />
          @if (
            loanForm.get("personalNetWorth")?.touched &&
            loanForm.get("personalNetWorth")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("personalNetWorth")
            }}</span>
          }
        </div>

        <!-- Personal Loans Amount -->
        <div class="form-group">
          <label for="personalLoans">Personal Loans Amount (in USD)</label>
          <input
            id="personalLoans"
            type="number"
            step="any"
            formControlName="personalLoans"
            placeholder="0.00"
          />
          @if (
            loanForm.get("personalLoans")?.touched &&
            loanForm.get("personalLoans")?.invalid
          ) {
            <span class="error-message">{{
              getErrorMessage("personalLoans")
            }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Financial Documentation Section -->
    <div class="form-section">
      <h3 class="section-title">Financial Documentation</h3>
      <div class="form-grid">
        <div class="form-group full-width">
          <span class="group-label required"
            >What financial documentation do you have available?</span
          >
          <div class="checkbox-grid" formGroupName="financialDocumentation">
            @for (option of financialDocOptions; track option) {
              <div class="checkbox-item">
                <input
                  type="checkbox"
                  [id]="'finDoc' + sanitizeKey(option)"
                  [formControlName]="sanitizeKey(option)"
                />
                <label [for]="'finDoc' + sanitizeKey(option)">{{
                  option
                }}</label>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</form>
